import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-screwdriver-icon',
  templateUrl: './tools-screwdriver.component.html'
})
export class ToolsScrewdriverComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
